import author from 'react-xocs/dist/xocs/references/author';
import etAl from 'react-xocs/dist/xocs/references/et-al';
import { skip } from 'react-xocs/dist/xocs/xocs-core';
import ArticleAuthors from '../../articleAuthors/articleAuthors';

const xocs = {
  author,
  'et-al': etAl,
  ellipsis: () => '...',
  collaboration: skip,
};

export default function authors(context, content, key = 0) {
  const authorList = content.$$.map(e => xocs[e['#name']](context, e, key));
  return (
    <div key={key} className="reference-panel-authors text-xs">
      {authorList.length > 0 && <ArticleAuthors authors={authorList} />}
    </div>
  );
}
